<template>
  <div>
    <div v-if="status === false" class="text-center my-5 py-5 font-2xl">
      <strong>There is currently no data for this section</strong>
    </div>
    <slot v-else />
  </div>
</template>

<script>
	export default {
		name: 'ConditionalTab',
    props: {
		  status: Boolean
    }
	};
</script>

<style scoped>

</style>
